import { FilterBuilderParam } from 'src/app/models/filter-builder';
import { Actions, WorkflowApplicationVM } from 'src/app/models';
import { PreviousRouteService } from './../../../../services/previous-route';
import { ToastrService } from 'ngx-toastr';
import { DataTableHelpers } from 'src/app/components/system/datatable/datatable-helper';
import { WorkflowContextService, DataService, ContractorService, SecurityService, WorkflowService, PublishHistory, Utilities } from 'src/app/services';
import { Subject, switchMap, of, Subscription, skip, map, BehaviorSubject, firstValueFrom } from 'rxjs';
import { TableColumn } from 'src/app/components/common/common-table/common-table.component';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkflowJanusService } from '../workflow-janus.service';
import { ItemSearchUtils, ItemSearchOptionField, ItemSearchOptionFieldOption, ItemSearchFilter } from 'src/app/components/filter-list/models/filterClasses';
import { FilterBuilderParamOpts } from 'src/app/models/filter-builder';
import { Workflow, WorkflowType } from 'src/app/models/workflow';
import { myWorkOptions } from 'src/app/components/common/common-filterbuilder-staff-janus/common-filterbuilder-staff-janus.model';
import moment from 'moment';
import { MapDataRequest } from 'src/app/components/arcgis/basic-esri-map/basic-esri-map.component';
import { GeomUtils } from 'src/app/components/arcgis/geom-utils';
import { BulkAction } from 'src/app/components/system/datatable/datatable.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { BulkCloseApplicationRequest } from 'src/app/models/close-application-request'; // added by Deepak on 18-04-2026
import { ClickableCellComponent } from 'src/app/components/common/common-table/clickable-cell/clickable-cell.component';

export enum ApplicationStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Voided = 3,
  Rejected = 4,
  Discarded = 5,
  Expired = 6,
  Locked = 7,
  Withdrawn = 8
}

@Component({
  selector: 'app-workflow-view-details',
  templateUrl: './workflow-view-details.component.html',
  styleUrls: ['./workflow-view-details.component.scss'],
  standalone: false
})
export class WorkflowViewDetailsComponent implements OnInit, OnDestroy {

  workflows: Workflow[];
  workflow: Workflow | undefined;
  columns: TableColumn[] = [];
  publishHistoryColumns: TableColumn[] = [];
  public filterCriteria: FilterBuilderParam[];
  filterInputs: ItemSearchOptionField[] = [];
  private filterSub?: Subscription;
  workflowOpts: FilterBuilderParamOpts[] = [];
  mapPopupActions = [
    {
      // This text is displayed as a tooltip
      title: 'View Application',
      // The ID by which to reference the action in the event handler
      id: 'view-application',
      // Sets the icon font used to style the action button
      className: 'esri-icon-zoom-out-magnifying-glass',
      // Handler of the action
      handler: item => {
        // navigate to the application
        this.router.navigate([
          `/application/workflow-application/${item.appId}`
        ]);
      }
    },
    GeomUtils.CopyCoordinatesToClipboardAction,
    GeomUtils.NavigateToGoogleAction,
    GeomUtils.NavigateToBingAction,
  ];
  // @Input() disable: boolean;
  // @Input() publish: boolean;
  // @Input() history: boolean;
  // @Input() builder: boolean;
  // @Input() start: boolean;
  // @Input() archive: boolean;
  @Input() isLoading: boolean = false;
  startAppLink : string = '';
  startAppLinkWithParcelId : string = '';
  @Output() action = new EventEmitter<{ action: string; row: any}>();
  @ViewChild('bulkActionConfirm', { static: true })
  bulkActionConfirm: ModalConfirmComponent;

  isEditorVisible: boolean = false;
  workflowDetailsColumns: any;
  tempDate = new Date().getTime();
  lastPublishedOn: string = this.tempDate + ' by Jane Smith';
  tabsList = ['data', 'map'];
  selectedIndex = 0;
  activeMainTab!: string;
  requestDataEvent: Subject<boolean> = new Subject<boolean>();
  requestMapDataEvent: Subject<boolean> = new Subject<boolean>();

  mapDataRequest: MapDataRequest;
  private q?: MapDataRequest;

  private readonly PAGE_SIZE_STORAGE_KEY ='wm-common-table-page-size-workflow-applications-janus';

  public filterOptions: ItemSearchOptionField[] = [];
  staticFilters: ItemSearchOptionField[] = [] ;
  public sortField = 'dateCreated';
  public sortDescending = true;
  applications: WorkflowApplicationVM[] = [];
  public recordCount = 0;
  isDestroyed = false;
  public showAll = false;
  unpermissibleCount = 0;
  recordCountSet = new EventEmitter<number>();
  dataLoaded = new EventEmitter<string>();

  mapFilters$ = new BehaviorSubject<any>(null);

  permissions: any;

  public page = {
    size: 10,
    totalElements: 0,
    totalPages: 0,
    pageNumber: 0
  };

  publishRows: PublishHistory[] = null;
  publishPage: number = 0;
  publishPageSize: number = 5;
  publishTotal: number;
  publishLoading: boolean = false;
  editWorkflow: boolean = false;

  bulkActions: BulkAction[] = [];
  selected: any[] = [];
  selectedIds: Set<string> = new Set();//added by Deepak on 18-04-2026
  loading = true;//added by Deepak on 18-04-2026
  requestedStatus: ApplicationStatus;
  bulkActionText: string = '';
  now = Date.now();
  pipe = new DatePipe('en-US');
  bulkActionForm: UntypedFormGroup = new UntypedFormGroup({
    bulkActionReason: new UntypedFormControl('', [Validators.required]),
    bulkActionDateTime: new UntypedFormControl({
      value: this.pipe.transform(this.now, 'MM/dd/yyyy h:mm:ss a'),
      disabled: true
    }),
    bulkActionUser: new UntypedFormControl({
      value: this._context.user ? this._context.user.userName : '',
      disabled: true
    })
  });

  description: string = '';

  startApplicationUrlModal: CommonConfirmationModalData = {
    open: false,
    closeBtn: true,
    modalDescp: 'Start Application Link',
    status: 'default',
    modalWidth: 'auto',
    // modalWidth: '687px', //Commented by Sanchit on 04/21/2026
    // modalHeight: '310px', //Commented by Sanchit on 04/21/2026
  }

  startApplicationParcelModal: CommonConfirmationModalData = {
    open: false,
    closeBtn: true,
    modalDescp: 'Start Application Link',
    status: 'default',
    modalWidth: 'auto',
    // modalWidth: '687px', //Commented by Sanchit on 04/21/2026
    // modalHeight: '310px', //Commented by Sanchit on 04/21/2026
  }

  publishHistoryConfirmModal: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Workflow Publish History',
    closeBtn: true,
    status: 'default',
    modalWidth: 'auto',
    customClass: 'publish-history-modal-btn' // Code added by Sanchit on 06/17/2026
    // modalWidth: '687px', //Commented by Sanchit on 04/21/2026
    // modalHeight: '410px' //Commented by Sanchit on 04/21/2026
  };

  get bulkActionReason() {
    return this.bulkActionForm.get('bulkActionReason');
  }

  async onBulkActionClick(action: BulkAction) {
    if (!this.selected?.length) return;

    const rows = this.selected.map(id => ({ id }));

    try {
      await action.action(rows);
    } catch (e) {
      console.error('Bulk action failed', e);
    }
  }

  canEditWorkflow: boolean;
  isRenewable = false;
  clientId: string;

  constructor(
    private workflowJanusService: WorkflowJanusService,
    public _context: WorkflowContextService,
    public _dataSvc: DataService,
    public workflowSvc: WorkflowService,
    private _contractorSvc: ContractorService,
    public router: Router,
    public route: ActivatedRoute,
    private dtHelpers: DataTableHelpers,
    private toast: ToastrService,
    private _securitySvc: SecurityService,
    public ref: ChangeDetectorRef,
    public prevRouteSvc: PreviousRouteService
  ) { }

  getPrefixNumber() {
    if (this.workflow?.numberPrefixCriteria) {
      if (this.workflow?.numberPrefixCriteria.length > 1) {
        return 'Conditional';
      } else {
        return this.workflow?.numberPrefixCriteria[0].value;
      }
    }
  }

  myWorkOptions: myWorkOptions[] = [
    {
      name: 'My Workflow Applications',
      templateId: 'myWorkflowApplications',
      displayOrder: 1,
      value: 'submitterId',
      searchText: this._context.user.id
    },
    {
      name: 'Workflow Applications Shared By Me',
      templateId: 'applicationsSharedByMe',
      displayOrder: 2,
      value: 'sharedByMe',
      searchText: this._context.user.userName
    },
    {
      name: 'Workflow Applications Shared With Me',
      templateId: 'applicationsSharedWithMe',
      displayOrder: 3,
      value: 'sharedWithMe',
      searchText: this._context.user.userName
    },
    {
      name: 'Applications Needing My Attention',
      templateId: 'applicationsNeedingMyAttention',
      displayOrder: 4,
      value: 'relevantToUser',
      filterText: 'true',
      searchText:null
    },
    {
      name: 'Applications Pending Payment',
      templateId: 'pendingPayment',
      displayOrder: 5,
      value: 'PendingPayments',
      searchText: '0',
      strOperator: '>'
    }
  ];

  private loadBulkActions() {
    this._securitySvc
      ?.isLoginEntitled('WORKFLOW_APPLICATIONS_BULK')
      ?.subscribe(isEntitled => {
        if (!isEntitled) return;

        this.bulkActions.push({
          name: 'Void',
          id: 'void',
          action: async rows => {
            const applicationIds = rows.map(r => r.id);
            this.selected = applicationIds;

            this.requestedStatus = ApplicationStatus.Voided;
            this.bulkActionText = 'Void';

            this.bulkActionForm.controls['bulkActionDateTime'].setValue(
              this.pipe.transform(Date.now(), 'MM/dd/yyyy h:mm:ss a')
            );

            this.bulkActionReason.reset();

            this.bulkActionConfirm.open();

            // this.bulkActionConfirm.open();

            return false;
          }
        });

        this.bulkActions.push({
          name: 'Expire',
          id: 'expire',
          action: async rows => {
            const applicationIds = rows.map(r => r.id);
            this.selected = applicationIds;

            this.requestedStatus = ApplicationStatus.Expired;

            this.bulkActionText = 'Expire';

            this.bulkActionForm.controls['bulkActionDateTime'].setValue(
              this.pipe.transform(Date.now(), 'MM/dd/yyyy h:mm:ss a')
            );

            this.bulkActionReason.reset();

            this.bulkActionConfirm.open();

            return false;
          }
        });

        this.bulkActions.push({
          name: 'Lock',
          id: 'lock',
          action: async rows => {
            const applicationIds = rows.map(r => r.id);
            this.selected = applicationIds;

            this.requestedStatus = ApplicationStatus.Locked;

            this.bulkActionText = 'Lock';

            this.bulkActionForm.controls['bulkActionDateTime'].setValue(
              this.pipe.transform(Date.now(), 'MM/dd/yyyy h:mm:ss a')
            );

            this.bulkActionReason.reset();

            this.bulkActionConfirm.open();
            return false;
          }
        });

        this.bulkActions.push({
          name: 'Withdraw',
          id: 'withdraw',
          action: async rows => {
            const applicationIds = rows.map(r => r.id);
            this.selected = applicationIds;

            this.requestedStatus = ApplicationStatus.Withdrawn;

            this.bulkActionText = 'Withdraw';

            this.bulkActionForm.controls['bulkActionDateTime'].setValue(
              this.pipe.transform(Date.now(), 'MM/dd/yyyy h:mm:ss a')
            );

            this.bulkActionReason.reset();

            this.bulkActionConfirm.open();
            return false;
          }
        });
      });
  }

  async loadWorkflow() {
    const workflowId = this.route.snapshot?.params?.['id'];

    if (!workflowId) {
      return;
    }

    const wf = await firstValueFrom(
      this.workflowSvc.getWorkflow(workflowId, false)
    );

    this.workflowJanusService.setSelectedWorkflow(wf);

    const workflow = this.workflowJanusService.getSelectedWorkflow();

    this.workflow = workflow;

    this.requestData();
  }
  rootPath = Utilities.getRootURL();
  async ngOnInit() {
      const storedPageSize = localStorage.getItem(this.PAGE_SIZE_STORAGE_KEY);

      if (storedPageSize) {
        const pageSize = Number(storedPageSize);

        if ([10, 25, 100, 200].includes(pageSize)) {
          this.page.size = pageSize;
        }
      }

    this.isEditorVisible = true;

    this.workflows = this.workflowJanusService.getWorkflows();
    this.permissions = this.workflowJanusService.getData().permissions;
    //Start Added by Deepak on 18-04-2026
    this.workflowJanusService.data$.subscribe(data => {
    });
    this.workflowJanusService.bulkSelection$.subscribe(selection => {
      this.selected = selection;
    });
    // End by Deepak on 18-04-2026
    this.loadBulkActions();

    await this.loadWorkflow();

    this.workflowDetailsColumns = [
      {
        key: 'numberPrefix',
        name: 'Number Prefix',
        value: this.getPrefixNumber()
      },
      {
        key: 'nextNumber',
        name: 'Next Number',
        value: this.workflow?.clientApplicationNumber
      },
      {
        key: 'public',
        name: 'Public',
        value: this.workflow?.visibleToPublic ? 'Yes' : 'No'
      },
      {
        key: 'archived',
        name: 'Archived',
        value: this.workflow?.isArchived ? 'Yes' : 'No'
      },
      {
        key: 'enabled',
        name: 'Enabled',
        value: this.workflow?.isEnabled ? 'Yes' : 'No'
      }
    ];

    this.columns = [
      {
        key: 'selected',
        headerType: 'checkbox',
        cellType: 'checkbox',
        sortable: false,
        hideMenu: true
      },
      {
        key: 'applicationNumber',
        label: 'App #',
        headerType: 'text',
        cellType: 'component',
        component: ClickableCellComponent,
        componentInputs: row => ({
          text: row.applicationNumber,
          row: row
        }),
        componentOutputs: {
          clicked: rowData => this.onNameClick(rowData)
        }
      },
      {
        key: 'permitType',
        label: 'App Type',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'description',
        label: 'Description',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'applicantsName',
        label: 'Applicant',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'dateCreated',
        label: 'Date Created',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'status',
        label: 'Status',
        headerType: 'text',
        cellType: 'text',
      },
      {
        key: 'currentActivityName',
        label: 'Current Activity',
        headerType: 'text',
        cellType: 'text',
      },

    ];

    this.publishHistoryColumns = [
      {
        key: 'lastPublishedBy',
        label: 'Published By',
        headerType: 'text',
        cellType: 'text',
        sortable: false,
        hideMenu: true
      },
      {
        key: 'lastPublishedOnString',
        label: 'Published On',
        headerType: 'text',
        cellType: 'text',
        sortable: false,
        hideMenu: true
      },
      {
        key: 'reason',
        label: 'Reason',
        headerType: 'text',
        cellType: 'text',
        sortable: false,
        hideMenu: true
      },
      {
        key: '$id',
        label: 'Version',
        headerType: 'text',
        cellType: 'text',
        sortable: false,
        hideMenu: true
      },
    ];

    this.selectedIndex = 0;
    this.activeMainTab = this.tabsList[this.selectedIndex];

    this.requestDataEvent.pipe(
      switchMap(() => {
        if (!this.workflow?.id) {
          return of({
            workflowApplications: [],
            recordCount: 0,
            pageCount: 0,
            unpermissibleCount: 0
          });
        }
        this.isLoading = true;
        this.detectChanges();

        if (this._context.user) {
          const serviceData = this.workflowJanusService.getData();
          const simpleSearchValue = this.getSimpleSearchValue(serviceData.searchText);

          const filter = this.getMergedFilters(!!simpleSearchValue);

          return this._dataSvc.getAllWorkflowApplications(
            this.workflow.id,
            this.sortField,
            this.sortDescending,
            filter,
            this.page.pageNumber+1,
            this.page.size,
            null,
            this.showAll
          );
        } else {
          return null;
        }
    })).subscribe({
      next: (applications) => {
        this.unpermissibleCount = applications.unpermissibleCount;
        this.page.totalElements = applications.recordCount;
        this.page.totalPages = applications.pageCount;

        const simpleSearchValue = this.getSimpleSearchValue(
          this.workflowJanusService.getData().searchText
        );

        let rows = applications.workflowApplications.map(wa => {
          this.description = wa.description;
          return {
            ...wa,
            dateCreated: this.pipe.transform(wa.dateCreated, 'MM/dd/yyyy'),
            status: ApplicationStatus[Number(wa.status)],
            currentActivityDetails: wa.currentActivityData ? JSON.parse(wa.currentActivityData).sort((a, b) => this.sortField == 'currentActivityName' && a.activityName > b.activityName ? this.sortDescending ? -1 : 1 : this.sortDescending ? 1 : -1) : null

          };
        });

        if (simpleSearchValue) {
          rows = rows.filter(row =>
            Object.values(row)
              .some(val => String(val).toLowerCase().includes(simpleSearchValue.toLowerCase()))
          );
        }

        //Start by Deepak on 18-04-2026 - restore checkbox state after data reload
        // this.applications = rows;
        this.applications = rows.map(row => ({
          ...row,
          selected: this.selectedIds.has(row.id) // 🔥 restore checkbox state
        }));
        // End by Deepak on 18-04-2026
        this.recordCountSet.emit(this.recordCount);

        this.isLoading = false;
        this.detectChanges();
        this.emitDataLoaded();
      },
      error: (err) => {
        console.error('Error occurred while fetching applications data:', err);
        this.isLoading = false;
        this.detectChanges();
      }

    });

    this.requestMapDataEvent.pipe(switchMap(() => {
      const filter = ItemSearchUtils.mergeFilters(
        this.mapDataRequest.query, this.staticFilters
      );

      return this._dataSvc
        .getAllWorkflowApplications(
          this.workflow.id,
          null,
          false,
          filter,
          1,
          500,
          this.mapDataRequest.ext,
          this.showAll
        ).pipe(map(data => data.workflowApplications));
    })).subscribe(data => {
      const appsMapped = data.map(app => {
        return {
          geometryWkts: app.geometryWkts,
          data: {
            appId: app.id,
            applicantsName: app.applicantsName,
            applicationNumber: app.applicationNumber,
            dateCreated: moment(app.dateCreated).format('MM/DD/YYYY hh:mm A'),
            description: app.description,
            permitType: app.permitType,
            status: ApplicationStatus[parseFloat(app.status)],
          }
        }
      });

      this.mapDataRequest.gimmeTheData$.emit(appsMapped);
      this.mapDataRequest = null;
    });

    if (this.workflows) {
      this.workflowOpts = [
        ...this.workflows.map(wf => ({
          name: wf.version.name,
          value: wf.id
        }))
      ];
    }
    this.initFilters();
    this.requestData();


    this.filterSub = this.workflowJanusService.data$.pipe(skip(1)).subscribe(data => {
      this.requestData();
      this.emitMapRefresh();

      this.filterOptions = [];
    });
  }

  ngOnDestroy(): void {
    if (this.requestDataEvent) {
      this.requestDataEvent.unsubscribe();
      this.requestDataEvent = null;
    }

    if (this.requestMapDataEvent) {
      this.requestMapDataEvent.unsubscribe();
      this.requestMapDataEvent = null;
    }

    this.filterSub?.unsubscribe();

    this.ref.detach();
  }

  initFilters(): Promise<void> {
    // if we have a client on the context then get workflows, otherwise call getPublicWorkflows
    //  GetWorkflows will filter out workflows by client Id and we don't have a client id
    const workflows = (this._context.client ? this._dataSvc
    .getWorkflows(this._context.client, false) : this._dataSvc
    .getPublicWorkflows(null, false))
    .toPromise();

    // if we have a client on the context then get the contractor types, otherwise return an empty list
    const contractorWorkflows = (this._context.client ? this._contractorSvc
      .getContractorRegistrationTypes(this._context.client.id)
      : of([])).toPromise();

    return Promise.all([workflows, contractorWorkflows]).then(
      ([workflows, contractorWorkflows]) => {
        let workflowOpts = [
          ...workflows.map(wf => ({
            name: wf.version.name,
            value: wf.id
          })),
          ...contractorWorkflows.map(c => ({
            name: `${c.name} (Registration)`,
            value: c.registerWorkflowId
          })),
          ...contractorWorkflows.map(c => ({
            name: `${c.name} (Renewal)`,
            value: c.renewWorkflowId
          }))
        ].sort((a,b) => a.name.localeCompare(b.name));

        // workflowOpts = workflowOpts.sort((a, b) =>
        //   a.name.localeCompare(b.name)
        // );

        this.filterCriteria = [
          {
            name: 'App #',
            id: 'applicationNumber'
          },
          {
            name: 'App Type',
            id: 'permitType',
            types: ['is', 'in'],
            options: this.workflowOpts
          },
          {
            name: 'Description',
            id: 'description'
          },
          {
            name: 'Applicant',
            id: 'applicantsName'
          },
          {
            name: 'Date Created',
            id: 'dateCreated',
            inputType: 'date',
            types: ['is', 'range']
          },
          {
            name: 'Submitter',
            id: 'submitterId',
            types: ['is']
          },
          {
            name: 'Status',
            id: 'status',
            types: ['is', 'in'],
            options: [
              {
                name: 'Not Started',
                value: '0'
              },
              {
                name: 'In Progress',
                value: '1'
              },
              {
                name: 'Completed',
                value: '2'
              },
              {
                name: 'Expired',
                value: '6'
              },
              {
                name: 'Locked',
                value: '7'
              },
              {
                name: 'Withdrawn',
                value: '8'
              },
              {
                name: 'Voided',
                value: '3'
              },
              {
                name: 'Rejected',
                value: '4'
              },
              {
                name: 'Discarded',
                value: '5'
              }
            ]
          },
          {
            name: 'Parcel Address',
            id: 'parcelAddress'
          },
          {
            name: 'Parcel City',
            id: 'parcelCity',
            types: ['is', 'contains', 'in']
          },
          {
            name: 'Parcel Id',
            id: 'parcelId',
            types: ['is', 'contains', 'in']
          },
          {
            name: 'Parcel Owner',
            id: 'parcelOwner'
          },
          {
            name: 'Current Activity',
            id: 'currentActivity',
            types: ['is', 'contains', 'in']
          }
        ];

        const param = this.filterCriteria.find(p => p.id === 'permitType');

        param.options = workflowOpts
          .map(w => ({
            name: w.name,
            value: w.value
          }))
          .sort((a: any, b: any) => a.name - b.name);
      }
    );
  }

  onSortChanged(event: { sortField: string | null; sortDescending: boolean | null }): void {
    if (event.sortField === null) {
      // reset to default sorting
      this.sortField = 'dateCreated';   // choose your default
      this.sortDescending = false;
    } else {
      this.sortField = event.sortField;
      this.sortDescending = event.sortDescending ?? false;
    }
    this.page.pageNumber = 0;
    this.requestData();
  }

  onPageChange(page: number) {
    this.page.pageNumber = page;
    this.requestData();
  }

  detectChanges() {
    if (!this.isDestroyed) {
      this.ref.detectChanges();
    }
  }

  emitDataLoaded() {
    this.dataLoaded.emit('WorkflowApplicationListComponent');
  }

  requestData() {
    this.requestDataEvent.next(true);
  }

  onAction(event: {action: string; row: any}) {
    // this.action.emit(event);
    this.workflowJanusService.emitAction(event);
  }

  onTabChange(index: number): void {
    this.selectedIndex = index;
    this.activeMainTab = this.tabsList[this.selectedIndex];
    if (this.activeMainTab === 'data') {
      this.requestData();
    } else if (this.activeMainTab === 'map') {
      this.emitMapRefresh();
    }
    return;
  }

  formatTabLabel(tab: string): string {
    return tab.charAt(0).toUpperCase() + tab.slice(1);
  }

  close() {
    this.isEditorVisible = false;
    this.workflowJanusService.setNewWorkflowButtonDisabled(false);
    this.router.navigate([{ outlets: { listWorkflowSettings: null, archiveWorkflowSettings: null } }],
      { relativeTo: this.route.parent }
    );
  }

  private emitMapRefresh(): void {
    this.mapFilters$.next({ timestamp: Date.now() });
  }

  onMapDataRequested(q: MapDataRequest) {
    this.mapDataRequest = q;

    this.requestMapDataEvent.next(true);
  }

  // Common filter code added by Vipul on 02-04-2026
  private getSimpleSearchValue(filters: ItemSearchOptionField[]): string {
    return String(
      (filters || [])
        .flatMap(filter => filter.options || [])
        .find(option => option?.searchOptionMethod === 'simpleSearch')
        ?.filterText ||
      (filters || [])
        .flatMap(filter => filter.options || [])
        .find(option => option?.searchOptionMethod === 'simpleSearch')
        ?.searchText ||
      ''
    ).trim();
  }

  private getMergedFilters(excludeSimpleSearch: boolean = false): any[] {
    const serviceData = this.workflowJanusService.getData();
    const uiFilters = [
      ...(this.filterOptions || []),
      ...(serviceData.filterInputs || []),
      ...(serviceData.attributeFilterInputs || []),
      ...(serviceData.searchText || [])
    ].filter((f: any) => {
      if (!excludeSimpleSearch) {
        return true;
      }
      const title = String(f?.title || '').trim().toLowerCase();
      return title !== 'simplesearch';
    });

    const deptFields: ItemSearchOptionField[] = [{
        title: 'departmentId',
        options: [
          {
            title: 'departmentId',
            searchOptionMethod: '',
            searchText: this._context.staffDepartmentId,
            filterText: '',
            selected: true,
            strOperator: ''
          }
        ]
      }]
    const staticFields = this.staticFilters ? this.staticFilters : null;
    const deptStaticFields = ItemSearchUtils.mergeFilters(staticFields, deptFields);
    const filter = uiFilters.length ? ItemSearchUtils.mergeFilters(uiFilters, deptStaticFields) : deptStaticFields;
    return filter ? filter : [];
  }

  private triggerReload(data: any): void {
    this.workflowJanusService.setData(data);
  }

  private normalizeSearchFilters(filters: ItemSearchOptionField[]): ItemSearchOptionField[] {
    const searchValue = (filters || [])
      .flatMap(filter => filter.options || [])
      .map(option => String(option?.filterText || option?.searchText || '').trim())
      .find(value => value.length > 0);

    if (!searchValue) {
      return [];
    }

    return [
      new ItemSearchOptionField({
        title: 'simpleSearch',
        options: [
          new ItemSearchOptionFieldOption({
            title: 'simpleSearch',
            selected: true,
            filterText: searchValue,
            searchText: '',
            strOperator: '',
            searchOptionMethod: 'simpleSearch'
          })
        ]
      })
    ];
  }

  private normalizeApplicationOption(option: ItemSearchOptionFieldOption): ItemSearchOptionFieldOption {
    const options = (this.filterCriteria.find(attr => attr.id === 'permitType')?.options || []) as any[];
    const rawValue = String(option?.filterText || option?.searchText || '').trim();
    const matched = options.find(opt =>
      String(opt?.name || '').trim().toLowerCase() === rawValue.toLowerCase() ||
      String(opt?.value || '').trim() === rawValue
    );

    return new ItemSearchOptionFieldOption({
      ...option,
      filterText: '',
      searchText: matched ? String(matched.value) : rawValue
    });
  }

  private normalizeScheduledOnOption(option: ItemSearchOptionFieldOption): ItemSearchOptionFieldOption {
    const rawValue = String(option?.filterText || option?.searchText || '').trim();
    if (!rawValue) {
      return option;
    }

    if (option?.strOperator === 'range') {
      try {
        const parsed = JSON.parse(rawValue);
        const start = parsed?.start ? moment(parsed.start).format('MM/DD/YYYY') : parsed?.start;
        const end = parsed?.end ? moment(parsed.end).format('MM/DD/YYYY') : parsed?.end;

        return new ItemSearchOptionFieldOption({
          ...option,
          filterText: '',
          searchText: JSON.stringify({
            ...parsed,
            start: start ? moment(start).format('YYYY-MM-DD') : start,
            end: end ? moment(end).format('YYYY-MM-DD') : end
          })
        });
      } catch {
        return option;
      }
    }

    const normalizedDate = moment(
      rawValue,
      ['YYYY-MM-DD', 'DD-MM-YYYY', 'MM/DD/YYYY', moment.ISO_8601],
      true
    );
    if (!normalizedDate.isValid()) {
      return option;
    }

    return new ItemSearchOptionFieldOption({
      ...option,
      filterText: '',
      searchText: normalizedDate.isValid()
        ? normalizedDate.format('YYYY-MM-DD')
        : rawValue
    });
  }

  private normalizeAttributeFilters(filters: ItemSearchOptionField[]): ItemSearchOptionField[] {
    return (filters || []).map(filter => ({
      ...filter,
      options: (filter.options || []).map(option => {
        if (filter.title === 'permitType') {
          return this.normalizeApplicationOption(option);
        }

        if (filter.title === 'scheduledOn' || filter.title === 'requestedOn') {
          return this.normalizeScheduledOnOption(option);
        }

        return option;
      })
    }));
  }

  private normalizeExternalFilters(filters: ItemSearchOptionField[]): ItemSearchOptionField[] {
    return (filters || []).map(filter => {
      if (filter.title !== 'applicationMyWork') {
        return filter;
      }

      return {
        ...filter,
        options: (filter.options || []).map(option =>
          new ItemSearchOptionFieldOption({
            ...option,
            filterText: option?.filterText || option?.searchText || ''
          })
        )
      };
    });
  }

  get queueToolbarFilters(): ItemSearchOptionField[] {
    const data = this.workflowJanusService.getData();
    return [
      ...data.filterInputs,
      ...data.attributeFilterInputs,
      ...data.searchText
    ];
  }

  onSearch(newFilters: ItemSearchOptionField[]): void {
    this.workflowJanusService.setData({
      ...this.workflowJanusService.getData(),
      searchText: this.normalizeSearchFilters(newFilters),
      reRunApplicationTable: true
    });
  }

  onFilterChanged(newFilters: ItemSearchOptionField[]): void {
    const normalizedFilters = this.normalizeAttributeFilters(newFilters);
    const data = this.workflowJanusService.getData();

    this.triggerReload({
      ...data,
      attributeFilterInputs: normalizedFilters,
      reRunApplicationTable: true
    });
  }

  onExternalFiltersChanged(updated: ItemSearchOptionField[]): void {
    const normalizedExternalFilters = this.normalizeExternalFilters(updated);
    const effectiveExternalFilters = normalizedExternalFilters;
    this.filterInputs = effectiveExternalFilters;
    const data = this.workflowJanusService.getData();
    this.triggerReload({
      ...data,
      filterInputs: normalizedExternalFilters,
      reRunApplicationTable: true
    });
  }

  onAttribute(_value: string): void {}
  onBulk(value: string) {
  }
  // Common filter code added by Vipul on 02-04-2026

  openStartAppLinkConfirmationModal() {
    this.startAppLink = `<a href="${this.rootPath}/home/StartWorkflowApplication?WorkflowId='${(this.workflow?.id || '')}">Start ${this.workflow?.version?.name} Application</a>`
    this.startApplicationUrlModal = {
      open: true,
      modalWidth:'500px'
    };
  }

  openStartAppParcelConfirmationModal() {
    this.startAppLinkWithParcelId = `<a href="${this.rootPath}/home/StartWorkflowApplication?WorkflowId=${this.workflow?.id || ''}&ParcelID=${this.selected?.[0]?.parcelId || ''}">Start ${this.workflow?.version?.name || ''} Application</a>`;
    this.startApplicationParcelModal = {
      open: true,
      modalWidth:'500px'
    };
  }

  openPublishHistoryConfirmationModal() {
    this.getPublishHistory();
    this.publishHistoryConfirmModal = {
      open: true,
      modalDescp: 'Workflow Publish History',
    };
  }

  getPublishHistory() {
    this.publishLoading = true;
    this.workflowSvc.getPublishHistory(this.workflow.id, this.publishPage, this.publishPageSize)
      .subscribe(results => {
        this.publishTotal = results.totalCount;
        this.publishRows = results.history;
        this.publishLoading = false;
      });
  }

  settingsButtonClick() {
  // this.isEditorVisible = false;
  // this.close();
  this.editWorkflow = true;

  this.router.navigate(
    [
      {
        outlets: {
          editWorkflow: [this.workflow.id],   // open this
          listWorkflowSettings: null,              // close this
          archiveWorkflowSettings: null,              // close this
        }
      }
    ],
    {
      relativeTo: this.route.parent || this.route
    }
  );
}
//Start by Deepak on 18-04-2026 - Bulk selection handlers
  onRowToggle(row: any): void {
  const id = row.id;

  // 🔥 toggle based on Set (NOT row.selected)
  if (this.selectedIds.has(id)) {
    this.selectedIds.delete(id);
  } else {
    this.selectedIds.add(id);
  }

  // UI sync
  row.selected = this.selectedIds.has(id);

  this.selected = Array.from(this.selectedIds);
  this.workflowJanusService.setBulkSelection(this.selected);
}

onHeaderToggle(rows: any[]): void {
  const allSelected = rows.every(r => this.selectedIds.has(r.id));

  if (allSelected) {
    // unselect all current page
    rows.forEach(r => this.selectedIds.delete(r.id));
  } else {
    // select all current page
    rows.forEach(r => this.selectedIds.add(r.id));
  }

  // UI sync
  rows.forEach(r => {
    r.selected = this.selectedIds.has(r.id);
  });

  this.selected = Array.from(this.selectedIds);
  this.workflowJanusService.setBulkSelection(this.selected);
}

  async bulkCloseApplications(applicationIds: string[]) {
    try {
      this.loading = true;

      const bulkActionRequest = new BulkCloseApplicationRequest({
        applicationIds: applicationIds,
        requestedStatus: this.requestedStatus,
        reason: this.bulkActionReason.value,
        dateTime: new Date(),
        user: this._context.user.id
      });

      // await this.dataService
      //   .bulkCloseApplications(bulkActionRequest)
      //   .toPromise();

      this._dataSvc.bulkCloseApplications(bulkActionRequest).subscribe({
        next: _res => {
          this.toast.success(
            `Application(s) changed to ${
              ApplicationStatus[this.requestedStatus]
            }.`
          );

          // 🔥 2. Stop processing
          this.bulkActionConfirm.cancelProcessing();

          // 🔥 3. Modal close manually
          this.bulkActionConfirm.closeJanusModal();

          // 🔥 4. Table refresh
          // this.workflowApplicationsJanusSvc.setData({
          //   ...this.workflowApplicationsJanusSvc.getData(),
          //   reRunJanusApplicationDataTable: true
          // });

          // 🔥 5. Reset selection
          this.resetBulkSelection();

          this.requestData();

          // stay on same page
          const currentPage = this.route.snapshot.queryParamMap.get('p');
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              p: currentPage
            },
            queryParamsHandling: 'replace'
          });
        },
        error: _err => {
          this.toast.error('Bulk action failed.Please try again later');
          this.bulkActionConfirm.cancelProcessing();
        }
      });
    } catch (error) {
      this.toast.error('Bulk action failed.Please try again later');
      this.bulkActionConfirm.cancelProcessing();
    } finally {
      this.loading = false;
    }
  }
    resetBulkSelection() {
    //Clear selected IDs
    this.selected = [];
    this.selectedIds.clear(); // 🔥 VERY IMPORTANT
    this.workflowJanusService.setBulkSelection([]);

     // 3. UI checkbox reset
  this.applications = this.applications.map(row => ({
    ...row,
    selected: false
  }));
    //  Reset form state
    this.bulkActionForm.reset({
      bulkActionReason: '',
      bulkActionDateTime: this.pipe.transform(
        Date.now(),
        'MM/dd/yyyy h:mm:ss a'
      ),
      bulkActionUser: this._context.user ? this._context.user.userName : ''
    });


    // 5. TABLE REFRESH
  this.requestData();
  }
// End by Deepak on 18-04-2026 - Bulk selection handlers

// added by Vipul on 13-07-2026
onNameClick(row: any) {
  const segments = this.router.routerState.snapshot.url.split('/').slice(0, -3);
  this.router.navigate(
    [
      ...segments,
      'workflow-applications',
      'data'
    ],
    {
      queryParams: { id: row.id }
     }
  );
}
// end by Vipul on 13-07-2026

onRowsPerPageChange(size: number): void {
  const pageSize = Number(size) || 10;

  localStorage.setItem(
    this.PAGE_SIZE_STORAGE_KEY,
    String(pageSize)
  );

  this.page.size = pageSize;
  this.page.pageNumber = 0;

  this.requestData();
}
}
